import { Injectable } from '@angular/core';
import { TableDatasource } from '@core/api/table.datasource';
import { BatchJobSchedule } from './batch-job-schedule.model';
import { BatchJobScheduleSearchParams } from './batch-job-schedule-search-params.model';

@Injectable({
  providedIn: 'root',
})
export class BatchJobScheduleDatasource extends TableDatasource<
  BatchJobSchedule,
  BatchJobScheduleSearchParams
> {
  endpoint = '/api/admin/batchjobschedules';
  defaultSortField = 'koerselsTidspunkt';
  override defaultTake = 1000;
}
